(() => {
  const init = root => root.querySelectorAll('.hero-carousel').forEach(carousel => {
    if (carousel.dataset.ready) return;
    carousel.dataset.ready = 'true';
    const track = carousel.querySelector('.carousel-track');
    const slides = [...track.children];
    if (!slides.length) return;
    const events = new AbortController();
    const on = (target, type, fn, options = {}) => target.addEventListener(type, fn, { ...options, signal: events.signal });
    let index = 0, timer = null, hovered = false, touchPaused = false, keyboardPaused = false, pressing = false, origin = null, inView = true;
    const bar = document.createElement('div'); bar.className = 'wenick-carousel-bar';
    const dotsGroup = document.createElement('div'); dotsGroup.className = 'wenick-carousel-dots';
    bar.append(dotsGroup); carousel.append(bar);
    const dots = slides.map((_, i) => {
      const dot = document.createElement('button'); dot.type = 'button'; dot.className = 'wenick-carousel-dot';
      dot.setAttribute('aria-label', 'الصورة ' + (i + 1)); dot.append(document.createElement('span')); dotsGroup.append(dot); return dot;
    });
    const arrows = ['prev', 'next'].map((direction, i) => {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'carousel-arrow carousel-arrow-' + direction;
      button.textContent = i ? '›' : '‹'; button.setAttribute('aria-label', i ? 'الصورة التالية' : 'الصورة السابقة');
      track.append(button); return button;
    });
    const fit = () => {
      const image = slides[index].querySelector('img');
      if (image?.naturalWidth && image.naturalHeight) track.style.setProperty('--carousel-ratio', image.naturalWidth + ' / ' + image.naturalHeight);
    };
    const show = next => {
      index = (next + slides.length) % slides.length; carousel.dataset.activeSlide = String(index + 1);
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', String(i !== index)); slide.inert = i !== index; });
      fit();
    };
    const stop = () => { clearTimeout(timer); timer = null; carousel.dataset.autoplay = 'paused'; };
    const schedule = () => {
      stop(); const paused = hovered || touchPaused || keyboardPaused || pressing;
      carousel.classList.toggle('show-arrows', paused);
      if (slides.length < 2 || document.hidden || !inView || paused) return;
      carousel.dataset.autoplay = 'running';
      timer = setTimeout(() => { show(index + 1); schedule(); }, 5500);
    };
    const resumeTouch = () => { touchPaused = false; pressing = false; origin = null; schedule(); };
    track.querySelectorAll('img').forEach(image => on(image, 'load', fit));
    on(matchMedia('(max-width: 700px)'), 'change', fit);
    on(carousel, 'pointerenter', e => { if (e.pointerType === 'mouse') { hovered = true; schedule(); } });
    on(carousel, 'pointerleave', e => { if (e.pointerType === 'mouse') { hovered = false; pressing = false; origin = null; schedule(); } });
    on(track, 'pointerdown', e => {
      if (e.target.closest('button') || (e.pointerType === 'mouse' && e.button !== 0)) return;
      origin = { x: e.clientX, y: e.clientY, pointerType: e.pointerType, wasPaused: touchPaused };
      pressing = true; schedule(); track.setPointerCapture(e.pointerId);
    });
    on(track, 'pointerup', e => {
      if (!origin) return;
      const start = origin, dx = e.clientX - start.x, dy = e.clientY - start.y;
      origin = null; pressing = false;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        show(index + (dx < 0 ? 1 : -1)); touchPaused = false;
      } else if (Math.abs(dy) > 25) touchPaused = false;
      else if (start.pointerType !== 'mouse') touchPaused = !start.wasPaused;
      schedule();
    });
    on(track, 'pointercancel', resumeTouch);
    on(track, 'dragstart', e => e.preventDefault());
    arrows.forEach((button, i) => on(button, 'click', e => {
      show(index + (i ? 1 : -1));
      if (!hovered && !e.target.matches(':focus-visible')) touchPaused = true;
      schedule();
    }));
    dots.forEach((dot, i) => on(dot, 'click', () => { show(i); if (!hovered) touchPaused = true; schedule(); }));
    on(document, 'pointerdown', e => {
      if (!carousel.contains(e.target)) { touchPaused = false; keyboardPaused = false; schedule(); }
    }, { passive: true });
    on(document, 'touchmove', e => {
      if (!track.contains(e.target) && touchPaused) resumeTouch();
    }, { passive: true });
    on(window, 'scroll', () => { if (touchPaused) resumeTouch(); }, { passive: true });
    on(track, 'keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show(index + (e.key === 'ArrowRight' ? 1 : -1)); keyboardPaused = true; schedule(); }
      if (e.key === 'Escape') { keyboardPaused = false; touchPaused = false; schedule(); }
    });
    on(carousel, 'focusin', e => { if (e.target.matches(':focus-visible')) { keyboardPaused = true; schedule(); } });
    on(carousel, 'focusout', () => requestAnimationFrame(() => { if (!carousel.contains(document.activeElement)) { keyboardPaused = false; schedule(); } }));
    const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; if (!inView) { touchPaused = false; keyboardPaused = false; hovered = false; } schedule(); });
    observer.observe(carousel);
    on(document, 'visibilitychange', schedule);
    on(document, 'shopify:section:unload', e => { if (e.target.contains(carousel)) { stop(); observer.disconnect(); events.abort(); } });
    show(0); schedule();
  });
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
